export default "__VITE_ASSET__BlGCfsJP__"